import { observer } from "mobx-react-lite";
import styled from "styled-components";

import { useStores } from "../../stores/RootStore.ts";
import { Card, Muted, Page, Title } from "../ui/primitives.tsx";

const Choice = styled(Card).attrs({ as: "button", type: "button" })`
    font: inherit;
    color: inherit;
    text-align: left;
    cursor: pointer;
    &:hover {
        border-color: var(--accent);
    }
`;

const ChoiceTitle = styled.span`
    font-weight: 600;
    font-size: 17px;
`;

/** The first screen in the desktop app: set up mainions on a new server, or log in to mainions that already run. */
export const WelcomePage = observer(function WelcomePage() {
    const { setup, ui } = useStores();

    return (
        <Page>
            <Title>Welcome to mainions</Title>
            <Muted>Your minions run on your own server. Set one up, or connect to the one you already have.</Muted>
            <Choice
                onClick={() => {
                    setup.reset();
                    ui.show({ name: "setup" });
                }}
            >
                <ChoiceTitle>Set up mainions on a new server</ChoiceTitle>
                <Muted>You give us a fresh server and its login. We install and secure everything, which takes about 10 minutes.</Muted>
            </Choice>
            <Choice onClick={() => ui.show({ name: "login" })}>
                <ChoiceTitle>Log in to your mainions</ChoiceTitle>
                <Muted>Already set up? Log in with your server's address and your mainions password.</Muted>
            </Choice>
        </Page>
    );
});
